<footer class="chat-footer">
  <textarea
    class="chat-input"
    [(ngModel)]="text"
    (keydown)="onKeydown($event)"
    placeholder="Escribe tu pregunta..."
    [disabled]="disabled"
    rows="1"
    maxlength="2000"
    aria-label="Escribe tu mensaje">
  </textarea>
  <button
    class="send-btn"
    (click)="send()"
    [disabled]="!text.trim() || disabled"
    title="Enviar mensaje"
    aria-label="Enviar mensaje"
    type="button">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="22" y1="2" x2="11" y2="13"></line>
      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
    </svg>
  </button>
</footer>
